/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * A GPX the organizer picked, read in the browser into an editable course.
 *
 * Nothing is uploaded here — the file is only read, so the line, distance and
 * start/finish can be shown before the form is saved.
 *
 * Resolves `{ points, originalCount }` — every point in the file, unrounded —
 * or `null` when the file holds no usable track.
 */

import parseGpx from '../event-detail/parseGpx';
// import { simplifyPoints } from './routeMath';

export default function readGpxFile(file) {
  return new Promise((resolve) => {
    if (!file) { resolve(null); return; }
    const reader = new FileReader();
    reader.onload = () => {
      const parsed = parseGpx(String(reader.result || ''));
      if (!parsed) { resolve(null); return; }
      // Every point exactly as the file has it — no thinning — so the map line
      // and the attached GPX describe the same course to the same coordinates.
      // resolve({ points: simplifyPoints(parsed), originalCount: parsed.length });
      resolve({ points: parsed, originalCount: parsed.length });
    };
    reader.onerror = () => resolve(null);
    reader.readAsText(file);
  });
}
